module.exports = "::ng-deep #headers .row .col {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n\niframe {\n  width: 100%; }\n\n@media (max-width: 560px) {\n  #address {\n    width: 100%; } }\n\n@media (min-width: 561px) {\n  #address {\n    width: 50%; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/contact/contact.component.scss
// module id = ./src/app/components/contact/contact.component.scss
// module chunks = main